// AutoChatChatroomItem.js
import { connect } from 'react-redux';

import { push } from '../action/navigationAction.js';
import fetchMediaMenifestOfMessage from '../action/fetchMediaMenifestOfMessage.js';
import fetchMessageDetail from '../action/fetchMessageDetail.js';
import getMessageData from '../selector/getMessageData.js';
import getUserData from '../selector/getUserData.js';
import getUserProfileUrl from '../resource/getUserProfileUrl.js';
import getMeData from '../selector/getMeData.js';
import getMessageDataWithVariable, {
  VariableName,
} from '../selector/getMessageDataWithVariable.js';
import getAutoChatMessageIds from '../selector/getAutoChatMessageIds.js';
import getNotificationListData, {
  SortField,
  SortOrder,
} from '../selector/getNotificationListData.js';
import getOperationData from '../selector/getOperationData.js';
import getListData from '../selector/getListData.js';
import ChatroomItem from '../component/ChatroomItem.jsx';
import { notificationList } from '../resource/notificationConstants.js';
import { USER_ID as AUTO_CHAT_USER_ID } from '../resource/autoChatConstants.js';
import { breakpoint } from '../style/variables.js';

function mapStateToProps(state) {
  const participantId = AUTO_CHAT_USER_ID;
  const autoChatMessageIds = getAutoChatMessageIds(state) || [];
  const lastMessageId =
    autoChatMessageIds.length > 0
      ? autoChatMessageIds[autoChatMessageIds.length - 1]
      : undefined;
  const notificationReadIds = getListData(
    state,
    ['notification', 'me', notificationList.READ],
    'itemIds'
  );
  const lastNotificationId = getNotificationListData(
    state,
    notificationList.AUTO_CHAT,
    'lastItemId',
    SortField.TIMESTAMP,
    SortOrder.ASC
  );
  const meUsername = getMeData(state, 'username');
  const type = getMessageData(state, lastMessageId, 'type');
  const mediaType = getMessageData(state, lastMessageId, 'mediaType');
  const caption = getMessageDataWithVariable(
    state,
    lastMessageId,
    'captionText',
    `${VariableName.USERNAME}:${meUsername}`
  );
  const postedAtUnix = getMessageData(state, lastMessageId, 'postedAtUnix');
  const isMe = false;
  const hasUnread = !notificationReadIds?.includes(lastNotificationId);
  const isOnDesktop =
    getOperationData(state, ['device'], 'width') > breakpoint.mobile;
  const participantUsername = getUserData(state, participantId, 'username');
  return {
    participantId,
    participantUsername,
    lastMessageId,
    type,
    mediaType,
    caption,
    postedAtUnix,
    isMe,
    hasUnread,
    isOnDesktop,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchMediaMenifestOfMessage: messageId =>
      dispatch(fetchMediaMenifestOfMessage({ id: messageId })),
    directToUserProfile: ({ id, username }) =>
      dispatch(push(getUserProfileUrl({ userId: id, username }))),
    fetchMessageDetail: data => dispatch(fetchMessageDetail(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatroomItem);
